import { Component, Input, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import * as _ from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseComponent } from 'src/app/_base/base.component';
import { DiseaseMedicalEnum } from 'src/app/_enums/disease-medical.enum';
import { MedicalTestTypes } from 'src/app/_enums/test-type';
import { DiseaseMedical, GeneralUserData, UserHealthRecord } from 'src/app/_models';
import { LookUpInterFace } from 'src/app/_models/common/lookUp.interface';
import { DiseaseMedicalService } from 'src/app/_services/common/disease-medical-service';
import { LookUpService } from 'src/app/_services/lookup/lookup.service';
import { UserService } from 'src/app/_services/users/user.service';

import { modalConfiguration } from '../../../../_configs/modal.config';
import { PagedResult } from './../../../../_models/common/paged-result.interface';
import { MedicalRecords } from './../../../../_models/users/medical-records';

// import {trigger, state, style, transition, animate} from '@angular/animations';
@Component({
  selector: 'app-user-health-records',
  templateUrl: './user-health-records.component.html',
  styleUrls: ['./user-health-records.component.scss'],
  providers: [TranslatePipe],
  encapsulation: ViewEncapsulation.None
})
export class UserHealthRecordsComponent extends BaseComponent implements OnInit {
  @Input('healthRecords') healthRecords: UserHealthRecord[] = [];
  @Input('totalRecords') totalRecords: number;
  @Input('userInfo') userInfo: GeneralUserData = new GeneralUserData();
  @ViewChild('addMedicalLogsForm') addMedicalLogsForm;
  index: number;
  action: string;
  bsModalRef: BsModalRef;
  panelOpenState = false;
  bloodGroups: LookUpInterFace[] = [];
  medicalRecords: MedicalRecords = new MedicalRecords();
  // shamasneh refactor
  isActiveSpinner: boolean = false;
  userHealthRecord: UserHealthRecord = new UserHealthRecord();
  medicalTestTypes = MedicalTestTypes;
  SelectedUserHealthRecord: UserHealthRecord = new UserHealthRecord();
  userId: string;
  allDiseaseMediactions: DiseaseMedical[] = [];
  diseaseMedicalEnum = DiseaseMedicalEnum;
  userDiseasesAndMedicalsIds: number[] = [];
  showDropDownBlood: boolean = false;
  pageIndex: number = 0;
  pageSize: number = 5;
  selectedTestTypeFilter: number = null;
  isEditMedicalNote: boolean = false;
  medicalNote: string = null;
  constructor(
    public modalService: BsModalService,
    private _userService: UserService,
    private _lookUpService: LookUpService,
    private activatedRoute: ActivatedRoute,
    private _diseaseMedicalService: DiseaseMedicalService
  ) {
    super();
    this.userHealthRecord.testType = this.medicalTestTypes.Routine;
  }
  ngOnInit() {
    if (!this.userInfo.id) {
      this.getuserInfo();
    } else {
      this.getUserMedicalDiseases();
    }

    this.getBloodGroupLookUp();
    this.getAllMedicals();
  }

  showInputField() {
    this.isEditMedicalNote = true;
  }
  closeMedicalNote(): void {
    this.isEditMedicalNote = false;
  }
  closeModal() {
    this.bsModalRef.hide();
  }

  // shamasneh work start
  submit(edit: boolean, data: UserHealthRecord) {
    // check operatin add or edit
    if (edit) {
      data.userHealthRecordId = this.SelectedUserHealthRecord.userHealthRecordId;
      data.userId = this.SelectedUserHealthRecord.userId;
      this.isActiveSpinner = true;
      this._userService.updateUserHealthRecord(data).subscribe(
        () => {
          this.isActiveSpinner = false;
          this.showSuccess('modalMessges.Common.DataHasBeenSaved');
          this.reset();
          this.getHealthRecords(this.userInfo.id, false);
          this.bsModalRef.hide();
        },
        () => {
          this.isActiveSpinner = false;
        }
      );
    } else {
      this.userHealthRecord.userId = this.userInfo.id;
      this.isActiveSpinner = true;
      this._userService.addUserHealthRecord(this.userHealthRecord).subscribe(
        () => {
          this.showSuccess('modalMessges.Common.DataHasBeenSaved');
          this.reset();
          this.isActiveSpinner = false;
          this.getHealthRecords(this.userInfo.id, false);
        },
        () => {
          this.isActiveSpinner = false;
        }
      );
    }
  }

  reset() {
    this.userHealthRecord = new UserHealthRecord();
    this.addMedicalLogsForm.reset();
    this.SelectedUserHealthRecord = new UserHealthRecord();
  }

  getHealthRecords(userId: string, showMore: boolean) {
    if (!userId) {
      return;
    }
    this.isActiveSpinner = true;
    this._userService.getUserHealthRecordsByUserId(this.pageIndex, this.pageSize, userId, this.selectedTestTypeFilter).subscribe(
      (data: PagedResult<UserHealthRecord>) => {
        data.results.map(i => (i.testDate = new Date(i.testDate)));
        if (showMore) {
          data.results.map(i => (i.testDate = new Date(i.testDate)));
          this.healthRecords = this.healthRecords.concat(data.results);
        } else {
          this.healthRecords = [];
          this.healthRecords = data.results;
        }
        this.totalRecords = data.totalRecords;

        this.isActiveSpinner = false;
      },
      () => {
        this.isActiveSpinner = false;
      }
    );
  }

  getBloodGroupLookUp() {
    this.isActiveSpinner = true;
    this._lookUpService.getBloodGroupLookUp().subscribe(
      (data: LookUpInterFace[]) => {
        if (data.length > 0) {
          this.bloodGroups = data;
        }
        this.isActiveSpinner = false;
      },
      () => {
        this.isActiveSpinner = false;
      }
    );
  }

  getBloodGroupLabel(id: number) {
    if (this.bloodGroups.length > 0) {
      return this.bloodGroups.filter(i => i.id === id)[0].text;
    }
    return '';
  }

  // delete
  deleteUserHealthRecord(id: number) {
    if (id) {
      this.isActiveSpinner = true;
      this._userService.deleteUserHealthRecord(id).subscribe(
        () => {
          this.showSuccess('modalMessges.Common.DataHasBeenSaved');
          this.getHealthRecords(this.userInfo.id, false);
          this.bsModalRef.hide();
          this.isActiveSpinner = false;
        },
        () => {
          this.isActiveSpinner = false;
        }
      );
    }
  }
  // handle edit or delete popup
  openEditMedicalLogsModal(editMedicalLogsModal: TemplateRef<any>, action, value) {
    this.SelectedUserHealthRecord = _.cloneDeep(value);
    if (action === 'edit') {
      this.action = 'edit';
    } else if (action === 'delete') {
      this.action = 'delete';
    }
    this.bsModalRef = this.modalService.show(editMedicalLogsModal, modalConfiguration);
  }

  // get user info
  getuserInfo() {
    this.userId = this.activatedRoute.snapshot.parent.params['id'];
    if (this.userId) {
      this.isActiveSpinner = true;
      this._userService.getUserById(this.userId).subscribe(
        (data: GeneralUserData) => {
          if (data) {
            this.userInfo = data;
            this.getHealthRecords(this.userInfo.id, false);
            this.getUserMedicalDiseases();
          }
          this.isActiveSpinner = false;
        },
        () => {
          this.isActiveSpinner = false;
        }
      );
    }
  }

  // get all disease medicals
  getAllMedicals() {
    this.isActiveSpinner = true;
    this.allDiseaseMediactions = [];
    this._diseaseMedicalService.getAll().subscribe(
      (data: DiseaseMedical[]) => {
        this.allDiseaseMediactions = data;
        this.isActiveSpinner = false;
      },
      () => {
        this.isActiveSpinner = false;
      }
    );
  }

  // update user medical Note
  updateUserMedicalNote() {
    const obj = {
      userId: this.userInfo.id,
      medicalNote: this.medicalNote,
      userType: this.userInfo.userTypeId
    };
    this.isActiveSpinner = true;
    this._userService.updateUserMedicalNote(obj).subscribe(
      () => {
        this.showSuccess('modalMessges.Common.DataHasBeenSaved');
        this.userInfo.medicalNote = obj.medicalNote;
        this.isEditMedicalNote = false;
        this.isActiveSpinner = false;
      },
      () => {
        this.isActiveSpinner = false;
      }
    );
  }

  // get user mediacl diseases

  getUserMedicalDiseases() {
    this.isActiveSpinner = true;
    this.userDiseasesAndMedicalsIds = [];
    this._diseaseMedicalService.getUserDiseaseMedical(this.userInfo.id).subscribe(
      (data: number[]) => {
        this.userDiseasesAndMedicalsIds = data;
        this.isActiveSpinner = false;
      },
      () => {
        this.isActiveSpinner = false;
      }
    );
  }

  // add disease mediacal once click check box
  addDisease(data: DiseaseMedical, event: boolean) {
    if (event) {
      const obj = {
        userId: this.userInfo.id,
        diseaseMedicationTypeId: data.diseaseMedicationType,
        diseaseMedicationId: data.diseaseMedicationId
      };
      this.isActiveSpinner = true;
      this._diseaseMedicalService.addUserDisease(obj).subscribe(
        () => {
          this.isActiveSpinner = false;
          this.showSuccess('modalMessges.Common.DataHasBeenSaved');
          this.getUserMedicalDiseases();
        },
        () => {
          this.isActiveSpinner = false;
        }
      );
    } else {
      this.isActiveSpinner = true;
      this._diseaseMedicalService.deleteUserDiseaseMediacl(this.userInfo.id, data.diseaseMedicationId).subscribe(
        () => {
          this.showSuccess('modalMessges.Common.DataHasBeenSaved');
          this.isActiveSpinner = false;
          this.getUserMedicalDiseases();
        },
        () => {
          this.isActiveSpinner = false;
        }
      );
    }
  }
  //
  changeBloodGroup() {
    this.isActiveSpinner = true;
    this._userService
      .updateUserBloodGroup({
        userId: this.userInfo.id,
        bloodgroupId: this.userInfo.bloodGroupId,
        userTypeId: this.userInfo.userTypeId
      })
      .subscribe(
        () => {
          this.showSuccess('modalMessges.Common.DataHasBeenSaved');
          this.isActiveSpinner = false;
          this.showDropDownBlood = false;
        },
        () => {
          this.isActiveSpinner = false;
        }
      );
  }

  // handle show more
  showMore(concat: boolean) {
    if (concat) {
      this.pageIndex++;
    } else {
      this.pageIndex = 0;
    }
    this.getHealthRecords(this.userInfo.id, concat);
  }
}
